import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '../types';
import { NavigationConfiguration, NavigationConfigurationSetter } from '@/types';

export interface ConfigurationState {
	navigationConfigurations: {[key: string]: NavigationConfiguration};
}

const state: ConfigurationState = {
	/** Navigation Configuration by project */
	navigationConfigurations: {}
};

const actions: ActionTree<ConfigurationState, RootState> = {
	updateNavigationConfigurations({ commit }, setter) {
		commit('UPDATE_NAVIGATION_CONFIGURATIONS', setter);
	}
};

const mutations: MutationTree<ConfigurationState> = {
	UPDATE_NAVIGATION_CONFIGURATIONS(state, setter: NavigationConfigurationSetter) {
		state.navigationConfigurations[setter.projectToken] = setter.navigation;
	}
};

const getters: GetterTree<ConfigurationState, RootState> = {};

const configurationState: Module<ConfigurationState, RootState> = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};

export default configurationState;
